import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';

import './RenewConsentModal.css';
import { useRenewConsentModalContext } from 'pages/SharePage/Context/RenewConsentModalContext';
import { useNewConsentModalContext } from 'pages/SharePage/Context/NewConsentModalContext';
import { useUserContext } from 'store';

export function RenewConsentModal() {
  const [user] = useUserContext();
  const { renewConsentModalState, setRenewConsentModalState } =
    useRenewConsentModalContext();
  const { newConsentModalState, setNewConsentModalState } = useNewConsentModalContext();
  
  const initialStateModal = {
    isOpen: false,
    pat_name: 'Não Encontrado',
  };

  return (
    <Dialog
      className="renewConsentModal"
      open={renewConsentModalState.isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>Criar novo consetimento</DialogTitle>
      <DialogContent>
        <div className='renewConsentModal-text'>
          <p>
            O consentimento atual não é mais válido. Para que você possa
            gerenciar esse acesso ao RES é necessário criar um novo
            consentimento. Deseja permitir novamente o acesso de
            <b>
              {' '}
              {renewConsentModalState.pat_name}
              {' '}
            </b>
            ao RES?
          </p>
        </div>
      </DialogContent>
      <DialogActions>
        <button className="renewConsentModal-closeButton" onClick={() => setRenewConsentModalState(initialStateModal)} type="button">
          Cancelar
        </button>
        <button className="renewConsentModal-renewButton" onClick={() => {
          setRenewConsentModalState(initialStateModal)
          setNewConsentModalState({ ...newConsentModalState, isOpen: true, subjectId: user.cpf })
        }} type="button">
          Confirmar
        </button>
      </DialogActions>
    </Dialog>
  );
}